<div class="profile-box">
  <!-- box header section -->
  <div class="profile-box__header">
    <h1 class="profile-box__title">{{ 'global.comments' | translate }}</h1>
  </div>

  <!-- comments list -->
  @if (!commentsDataLoading) {
    @if (commentsData.length > 0) {
      <ul class="profile-box__content">
        @for (comment of commentsData; track comment._id) {
          <li class="profile-box__comment">
            <pwj-panel-comment [commentData]="comment"></pwj-panel-comment>
          </li>
        }
      </ul>
    } @else {
      <!-- no content component -->
      <pwj-no-content
        [message]="
          'profile.comments.noCommentMessage' | translate
        "></pwj-no-content>
    }
  } @else {
    <!-- skeleton -->
    <div>
      <pwj-panel-comment-skeleton [count]="3"></pwj-panel-comment-skeleton>
    </div>
  }
</div>
